module.exports = __webpack_public_path__ + "static/img/service_introduce_JP03_zh.29090a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_JP03_zh.png
// module id = Int1
// module chunks = 34